<div class="edit-container" fxLayout="column" *ngIf="loaded">
  <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
    <h3 fxLayout="row" fxLayoutAlign="start center">{{ requirement.scenarioRequirementDefinitionName }}</h3>
    <div class="button-container">
      <button type="button" class="text-uppercase" mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <a class="notes-link" [routerLink]="['/people/profile/' + personId + '/notes']"
    >See All Notes in Profile<mat-icon>call_made</mat-icon></a
  >
  <mat-divider></mat-divider>
  <div class="notes-card" *ngFor="let note of notes">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div class="field-container" fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between start">
        <div fxFlex fxLayout="column">
          <span class="note-description">{{ note.description }}</span>
          <span class="note-info"
            >{{ note.createdOn.toLocaleString() | localDate: 'MMM DD, YYYY hh:mm:ss A' }} by {{ note.createdBy }}</span
          >
        </div>
        <div class="note-delete">
          <button mat-icon-button aria-label="Delete Note" *ngIf="canDelete(note)">
            <mat-icon (click)="deleteNote(note)">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
</div>
